import { render, staticRenderFns } from "./disciplinesNew.vue?vue&type=template&id=1364ae3f&scoped=true"
import script from "./disciplinesNew.vue?vue&type=script&lang=js"
export * from "./disciplinesNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1364ae3f",
  null
  
)

export default component.exports